(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[25632],{

/***/ 17994:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/copiercosts",
      function () {
        return __webpack_require__(5390);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ CopierCostsHome; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88737);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22060);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _components_layouts_copierCostsWrapper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70704);
/* harmony import */ var _components_copiercosts_topSection__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20023);
/* harmony import */ var _components_shared_offersList__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33124);








const Benefits = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>__webpack_require__.e(/* import() */ 66688).then(__webpack_require__.bind(__webpack_require__, 66688)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(66688)
            ]
    }
});
const DoYouKnow = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>__webpack_require__.e(/* import() */ 58049).then(__webpack_require__.bind(__webpack_require__, 58049)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(58049)
            ]
    }
});
var __N_SSP = true;
function CopierCostsHome() {
    const { domain  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__/* .useDomainContext */ .w)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_layouts_copierCostsWrapper__WEBPACK_IMPORTED_MODULE_4__["default"], {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_copiercosts_topSection__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `px-4vw lg:px-4 ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_7___default().mxWrapper)}`,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_offersList__WEBPACK_IMPORTED_MODULE_6__["default"], {
                            offers: domain?.defaultOffers
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Benefits, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DoYouKnow, {})
                ]
            })
        ]
    });
}


/***/ }),

/***/ 20023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TopSection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/copiercosts/topSection/styles.module.scss
var styles_module = __webpack_require__(56905);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./src/components/shared/header/index.tsx
var header = __webpack_require__(74206);
// EXTERNAL MODULE: ./src/components/shared/form/index.tsx
var shared_form = __webpack_require__(96119);
// EXTERNAL MODULE: ./src/components/copiercosts/mainBanner/styles.module.scss
var mainBanner_styles_module = __webpack_require__(1452);
var mainBanner_styles_module_default = /*#__PURE__*/__webpack_require__.n(mainBanner_styles_module);
// EXTERNAL MODULE: ./src/styles/variables/copiercostsVariables.module.scss
var copiercostsVariables_module = __webpack_require__(17406);
var copiercostsVariables_module_default = /*#__PURE__*/__webpack_require__.n(copiercostsVariables_module);
;// CONCATENATED MODULE: ./src/components/copiercosts/mainBanner/index.tsx





function MainBanner() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (mainBanner_styles_module_default()).mainBannerWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (mainBanner_styles_module_default())["main-banner"],
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_form/* default */.Z, {
                classes: {
                    formClassName: (mainBanner_styles_module_default()).form,
                    stepTitleClassName: (mainBanner_styles_module_default())["step-title"],
                    stepDescriptionClassName: (mainBanner_styles_module_default())["step-description"],
                    formButtonClassName: (mainBanner_styles_module_default())["form-button"],
                    formFieldClassName: (mainBanner_styles_module_default())["form-field"],
                    formStepInnerClassName: (mainBanner_styles_module_default())["steps-inner"],
                    fieldsClassName: {
                        radio: (mainBanner_styles_module_default())["radio-field"]
                    },
                    fieldsWrapperClassName: (mainBanner_styles_module_default())["fields-wrapper"],
                    tcpaClassName: (mainBanner_styles_module_default()).tcpa,
                    labelAsTitleClassName: (mainBanner_styles_module_default())["label-as-step-title"],
                    formProgressbarClassName: (mainBanner_styles_module_default())["progress-background"],
                    stepClassName: (mainBanner_styles_module_default()).step
                },
                colors: {
                    primaryColor: (copiercostsVariables_module_default()).defaultButtonColor,
                    progressBar: (copiercostsVariables_module_default()).defaultProgressColor,
                    modalButtonTextColor: "#fff"
                },
                showProgress: true
            })
        })
    });
}

// EXTERNAL MODULE: ./src/components/copiercosts/mainImage/styles.module.scss
var mainImage_styles_module = __webpack_require__(6785);
var mainImage_styles_module_default = /*#__PURE__*/__webpack_require__.n(mainImage_styles_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/copiercosts/mainImage/index.tsx




function MainImage() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (mainImage_styles_module_default()).mainBannerWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: "/assets/images/bg.svg",
            className: (mainImage_styles_module_default())["background-img"],
            alt: "Digital Copier",
            layout: "intrinsic",
            priority: true,
            width: 875,
            height: 632
        })
    });
}

// EXTERNAL MODULE: ./src/components/copiercosts/logo/index.tsx
var logo = __webpack_require__(54794);
// EXTERNAL MODULE: ./src/components/shared/textBlockOffer/TextBlockOffer.tsx
var TextBlockOffer = __webpack_require__(45464);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/lib/sharedUtils.ts
var sharedUtils = __webpack_require__(75094);
;// CONCATENATED MODULE: ./src/components/copiercosts/topSection/index.tsx












function TopSection() {
    const router = (0,next_router.useRouter)();
    const { domain  } = (0,useDomainContext/* useDomainContext */.w)();
    const isFormDisplayed = (0,sharedUtils/* finalShowForm */.r6)(router.query.sl, domain.showForm, domain.defaultOffers);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: `${(styles_module_default()).topSection}`,
        children: isFormDisplayed ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: ` ${(styles_module_default()).mxWrapper}`,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(header["default"], {
                    slogan: "Top Digital Copier Companies",
                    textColor: (copiercostsVariables_module_default()).offerCallNumber,
                    backGroundColor: "transparent",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo/* default */.Z, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                    className: `px-4vw lg:px-4`,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: `flex flex-col md:flex-row items-center justify-between`,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainBanner, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainImage, {})
                        ]
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(header["default"], {
                    slogan: "Top Digital Copier Companies",
                    textColor: (copiercostsVariables_module_default()).offerCallNumber,
                    backGroundColor: "transparent",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo/* default */.Z, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBlockOffer/* default */.Z, {})
            ]
        })
    });
}


/***/ }),

/***/ 70704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ CopierCostsWrapper; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _hooks_useModalContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67379);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _copiercostsLayouts_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87631);
/* harmony import */ var _copiercostsLayouts_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_copiercostsLayouts_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _components_shared_blogPost_sideWidget_mobile__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8281);







const CloseIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(()=>__webpack_require__.e(/* import() */ 69655).then(__webpack_require__.bind(__webpack_require__, 69655)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69655)
            ]
    }
});
const TermsAndConditions = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(()=>Promise.all(/* import() */[__webpack_require__.e(10761), __webpack_require__.e(14777)]).then(__webpack_require__.bind(__webpack_require__, 10761)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10761)
            ]
    }
});
const PrivacyPolicy = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(()=>Promise.all(/* import() */[__webpack_require__.e(57079), __webpack_require__.e(25591)]).then(__webpack_require__.bind(__webpack_require__, 57079)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(57079)
            ]
    }
});
const Modal = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(()=>__webpack_require__.e(/* import() */ 18740).then(__webpack_require__.bind(__webpack_require__, 18740)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(18740)
            ]
    }
});
const MainLayout = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(()=>__webpack_require__.e(/* import() */ 50421).then(__webpack_require__.bind(__webpack_require__, 50421)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(50421)
            ]
    }
});
function CopierCostsWrapper({ children  }) {
    const { modal , closeModal  } = (0,_hooks_useModalContext__WEBPACK_IMPORTED_MODULE_3__/* .useModal */ .d)();
    const handleClose = ()=>{
        closeModal();
    };
    const { active: modalActive , content: modalContent  } = modal;
    const getModalContent = ()=>{
        switch(modalContent){
            case "privacy":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PrivacyPolicy, {
                    category: "Copier Costs",
                    domain: "CopierCosts.com"
                });
            case "terms":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TermsAndConditions, {
                    category: "Copier Costs",
                    domain: "CopierCosts.com"
                });
            case "sideWidget":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_blogPost_sideWidget_mobile__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {});
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.gstatic.com"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        href: "https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap",
                        rel: "stylesheet"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                style: {
                    fontFamily: `'Roboto', sans-serif`
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_copiercostsLayouts_module_scss__WEBPACK_IMPORTED_MODULE_6___default().mainDigitalCopierBg),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MainLayout, {
                            children: children
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Modal, {
                        onClose: handleClose,
                        active: modalActive,
                        closeIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CloseIcon, {}),
                        backdropClosable: true,
                        modalStyles: {
                            display: "flex",
                            flexDirection: "column",
                            maxHeight: modalContent === "sideWidget" ? "80vh" : "100%"
                        },
                        modalClassName: "h-[90vh] rounded",
                        bodyStyles: {
                            overflowY: "scroll"
                        },
                        width: 900,
                        header: modalContent === "privacy" ? "Privacy Policy" : modalContent === "terms" ? "Terms and Conditions" : modalContent === "sideWidget" ? "Contents" : undefined,
                        children: getModalContent()
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 22060:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mxWrapper":"style_mxWrapper__Gax_N"};

/***/ }),

/***/ 1452:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","mainBannerWrapper":"styles_mainBannerWrapper__NRvAy","main-banner":"styles_main-banner__1JFuF","form":"styles_form__DR4P6","steps-inner":"styles_steps-inner__BEQR5","step-title":"styles_step-title__vY3rc","label-as-step-title":"styles_label-as-step-title__LlpZ4","step-description":"styles_step-description__jr_yx","fields-wrapper":"styles_fields-wrapper__hSV3C","form-button":"styles_form-button__L2hsR","form-field":"styles_form-field__Jj2oI","radio-field":"styles_radio-field__NWDop","tcpa":"styles_tcpa__Zpepc","step":"styles_step__I_k_4","image":"styles_image__W3VFD","progress-background":"styles_progress-background__a8AkW"};

/***/ }),

/***/ 6785:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","mainBannerWrapper":"styles_mainBannerWrapper__sXOgx","main-banner":"styles_main-banner__6051R","form":"styles_form__bs5YU","steps-inner":"styles_steps-inner__wX0nv","step-title":"styles_step-title__sZUND","label-as-step-title":"styles_label-as-step-title__ukRs7","step-description":"styles_step-description__aDfbL","fields-wrapper":"styles_fields-wrapper__2oVtr","form-button":"styles_form-button__fY3YH","form-field":"styles_form-field__JRXPE","radio-field":"styles_radio-field__bnScl","tcpa":"styles_tcpa__5s41r","image":"styles_image__1jqVq","progress-background":"styles_progress-background__pnlKF"};

/***/ }),

/***/ 56905:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","topSection":"styles_topSection__Om8jo","mxWrapper":"styles_mxWrapper__l8Brb"};

/***/ }),

/***/ 87631:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [92592,10621,12672,2917,12189,49774,92888,40179], function() { return __webpack_exec__(17994); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);